import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";

class QueriesServed extends Component {

    render() {
        return (
            <div className="col-lg-12" style={{ marginLeft: "20px" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <ToastContainer className="Toast-at-center" />

                <div class="row mt-4 mb-4">
                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Queries Served<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.props.value.noOfUserQueryYesterday}{this.props.value.yesterdayUserQueryScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Yesterday</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Queries Served<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.props.value.noOfUserQuery7Day}{this.props.value.last7DayUserQueryScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Last 7 Days</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Queries Served<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.props.value.noOfUserQuery30Day}{this.props.value.last30DayUserQueryScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Last 30 Days</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default QueriesServed;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/conversationStat/QueriesServed.js